import React, { ReactNode } from 'react';
import Button, { ButtonProps } from '@material-ui/core/Button';
import { CustomTooltip } from '../Tooltip/Tooltip';
import { TooltipProps } from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import LoadingButton from '../../lowLevel/LoadingButton';

export interface CustomButtonProps extends ButtonProps {
  children?: ReactNode;
  wrapperClass?: string;
  useWrapper?: boolean;
  isLoader?: boolean;
  loading?: boolean;
  tooltipText?: string;
  tooltipProps?: Partial<TooltipProps>;
}

export default function CustomButton({
  children,
  wrapperClass = '',
  useWrapper = true,
  isLoader = false,
  loading = false,
  tooltipText,
  tooltipProps,
  ...buttonProps
}: CustomButtonProps) {
  const renderButton = () => {
    if (isLoader) {
      const { disabled = false } = buttonProps;
      return (
        <LoadingButton
          loading={loading}
          {...buttonProps}
          disabled={loading || disabled}
        >
          {children}
        </LoadingButton>
      );
    }
    return <Button {...buttonProps}>{children}</Button>;
  };
  return (
    <CustomTooltip
      arrow
      placement="top"
      title={tooltipText ? <Typography>{tooltipText}</Typography> : ''}
      {...tooltipProps}
    >
      {useWrapper ? (
        <div className={wrapperClass}>{renderButton()}</div>
      ) : (
        renderButton()
      )}
    </CustomTooltip>
  );
}
